// extracted by mini-css-extract-plugin
export default {"root":"pOYf38Sgh0amwWEsil5B","icon":"R102dgC27qpO7Swu0irq"};